import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpParams } from '@angular/common/http';
import { config } from 'app/app.config';

@Injectable({providedIn: 'root'})
export class ManageClientService {

    /** specifying Base URL.*/
    public BASE_URL = `${config.PROTOCOL}://${config.HOST}:${config.PORT}/canstring/${config.VERSION}`;

    constructor(private http: HttpClient) {
    }

    addNewClient(data) {
        return this.http.post(`${this.BASE_URL}/clients`, data);
    };

    getClientList(payLoad) {
        const Params = this.preHttpParams(payLoad);
        return this.http.get(`${this.BASE_URL}/clients`, { params: Params });
    };

    getSortAndSearch(payLoad) {
        return this.http.get(`${this.BASE_URL}/clients?offset=${payLoad.offset}&limit=${payLoad.limit}&sort=${payLoad.sort}&search=${payLoad.search}`);
    };

    getClientDetail(client_id?) {
        return this.http.get(`${this.BASE_URL}/clients/${client_id}`);
    };

    updateClientDetail(client_id, client) {
        return this.http.put(`${this.BASE_URL}/clients/${client_id}`, client);
    };

    activateAndDeactiveClient(client_id) {
        return this.http.patch(`${this.BASE_URL}/clients/${client_id}`, null);
    };

    deleteClientDetail(client_id) {
        return this.http.delete(`${this.BASE_URL}/clients/${client_id}`);
    };

    deleteClientProfile(client_id) {
        return this.http.delete(`${this.BASE_URL}/clients/deleteClientProfile/${client_id}`);
    };

    emitEmailToAllClients(payLoad) {
        return this.http.put(`${this.BASE_URL}/sendEmailToAllClient`, payLoad);
    };

    bulkClientCreate(payLoad) {
        return this.http.post(`${this.BASE_URL}/clients/bulk-client-create`, payLoad);
    };

    getBulkClientTemplate(): any {
        return this.http.get(`${this.BASE_URL}/clients/bulk-client-template`, { responseType: 'blob' });
    };

    preHttpParams(payLoad) {
        let Params = new HttpParams();
        for (const key in payLoad) {
            if (key && (payLoad[key] || payLoad[key] === 0)) {
                Params = Params.append(key, payLoad[key]);
            }
        }
        return Params;
    };
}

